import { type ObjectValuesUnionType } from '../utils/typing';

// Network status
export const NetworkStatuses = Object.freeze({
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
});

export type NetworkStatus = ObjectValuesUnionType<typeof NetworkStatuses>;
